/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{ title: NonNullable<unknown> }} Cmspost_Delete_Confirm1Inputs */

const vi_cmspost_delete_confirm1 = /** @type {(inputs: Cmspost_Delete_Confirm1Inputs) => LocalizedString} */ (i) => {
	return /** @type {LocalizedString} */ (`Xoá hẳn bài "${i?.title}"? Không khôi phục được.`)
};

/**

* @param {Cmspost_Delete_Confirm1Inputs} inputs
* @param {{ locale?: "vi" }} options
* @returns {LocalizedString}
*/
const cmspost_delete_confirm1 = /** @type {((inputs: Cmspost_Delete_Confirm1Inputs, options?: { locale?: "vi" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Cmspost_Delete_Confirm1Inputs, { locale?: "vi" }, {}>} */ ((inputs, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return vi_cmspost_delete_confirm1(inputs)
});
export { cmspost_delete_confirm1 as "cmsPost_delete_confirm" }